<template>
  <div class="market">
    <h1>{{ market.name }}</h1>
    <div class="broadcasts">
      <div v-for="(broadcast, index) in broadcasts" :key="index" class="item">
        <img :src="broadcast.logoUrl">
        <div class="info">
          <span>
            ID: <strong>{{ broadcast.id }}</strong>
            - Name: <strong>{{ broadcast.name }}</strong>
            - Live Data: <strong>{{ broadcast.hasLiveData }}</strong>
            - Freq: <strong>{{ broadcast.band }} / {{ broadcast.frequency }}</strong>
          </span>
          <stream-indicator
            :state="streamState(broadcast)"
            class="stream-indicator"
            :broadcast="broadcast"
            @click="playPauseStream(broadcast)"
          />
        </div>
      </div>
    </div>
    <dash-audio-player />
  </div>
</template>

<script>
import _ from 'lodash';
import { normalizedStreams } from '@ibiquity/dashboard.audio-player/src/utils';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { getBroadcast } from '@ibiquity/dashboard.conrad';
import { getMarket } from '@/services/market';
import { DashAudioPlayer } from '@ibiquity/dashboard.audio-player';
import StreamIndicator from '@/components/common/StreamIndicator';

export default {
  name: 'MarketList',
  components: {
    DashAudioPlayer,
    StreamIndicator,
  },
  data() {
    return {
      market: {},
      broadcasts: [],
    };
  },
  computed: {
    ...mapGetters('playback', ['isGivenBroadcastPlaying', 'playerState']),

    normalizedStreams() {
      return (broadcast) => {
        const streams = normalizedStreams(broadcast.streams);
        return streams?.length ? streams : null;
      };
    },
  },
  created() {
    const urlMarkets = this.$route.query.markets && this.$route.query.markets.split(',');
    const marketId = urlMarkets[0];

    getMarket(marketId)
      .then((market) => {
        this.market = market;
        return Promise.all(market.broadcasts
          .map(broadcast => getBroadcast(broadcast.id)
            .then((response) => {
              const { data: newBroadcast } = response;
              if (broadcast.streamUrl) {
                if (!newBroadcast.streams) newBroadcast.streams = [];
                newBroadcast.streams.unshift({ url: broadcast.streamUrl });
              }
              return newBroadcast;
            })
            .catch((error) => {
              this.$rollbar.warning(`Fetching Conrad Broadcast failed: ${error.message || error}`);
            })));
      })
      .then((broadcasts) => {
        this.broadcasts = _(broadcasts)
          .compact()
          .filter(broadcast => (broadcast.band !== 'AM'))
          .value();
      })
      .catch(error => this.$rollbar.warning(`Fetching Conrad data failed: ${error.message || error}`));
  },
  methods: {
    ...mapMutations('playback', ['setError']),
    ...mapActions('playback', ['switchPlayback']),

    playing(id) { return this.isGivenBroadcastPlaying(id); },

    streamState(broadcast) {
      const { id } = broadcast;
      if (!this.normalizedStreams(broadcast)) return 'no-stream';
      return this.playing(id) ? this.playerState : 'pause';
    },

    playPauseStream(broadcast) {
      const streams = this.normalizedStreams(broadcast);
      if (!streams) return;
      this.switchPlayback({
        broadcastId: broadcast.id,
        streams,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";

.market {
  background: $black;
  padding: 10px;
  color: $white;
  font-size: 16px;
  img {
    border: dashed 2px $grey-light;
    width: 150px;
  }
  .item {
    color: $grey-light;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid $charcoal-dark;
    display: flex;
    height: 150px;
  }
  .item strong {
    color: $white;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 0 auto;
    height: 80px;
    align-self: center;

    span, .stream-indicator {
      margin: 0 16px;
    }
    .stream-indicator {
      width: 36px;
      height: 36px;
    }

    h2 {
      font-size: 1.2em;
      margin: 0 16px;
      height: 40px;
      padding: 10px 0;
      box-sizing: border-box;
    }
  }
}
</style>
